export default "/images/cbebb0a7ebf84f6daf40662454c63a3d.avif";